module.exports = {"ADM_DASHBOARD_MAIN_TITLE":"Umum","ADM_DASHBOARD_SALES_TITLE":"","ADM_DASHBOARD_ACQUISITION_TITLE":"Akuisisi dan Retensi"}